import React, { FC } from 'react';

import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

const Datepicker: FC<ReactDatePickerProps> = ({ selected, onChange, ...rest }) => {
  return (
    <div>
      <ReactDatePicker {...rest} open={true} selected={selected} placeholderText="Enter a date" onChange={onChange} customInput={<></>} />
    </div>
  );
};

export default Datepicker;
